import { createEffect } from "solid-js";

export type PerformanceChartsScrollRestoreOptions = {
  getZoom: () => boolean;
  getScrollInner: () => HTMLElement | undefined;
};

/**
 * Preserves `.performance-charts-scroll-inner` scrollTop when entering plot zoom and restores it
 * after Solid remounts the multi-plot grid when zoom clears (including axis-change exits).
 */
export function createPerformanceChartsScrollRestore(
  opts: PerformanceChartsScrollRestoreOptions
): { captureBeforeEnteringPlotZoom: () => void } {
  let pending: number | null = null;

  const captureBeforeEnteringPlotZoom = (): void => {
    if (opts.getZoom()) return;
    pending = opts.getScrollInner()?.scrollTop ?? 0;
  };

  createEffect(() => {
    if (opts.getZoom()) return;
    if (pending === null) return;
    const y = pending;
    pending = null;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const el = opts.getScrollInner();
        if (el) el.scrollTop = y;
      });
    });
  });

  return { captureBeforeEnteringPlotZoom };
}
